module.exports = __webpack_public_path__ + "img/LogoTextEu-blue.aaea30e8.svg";